import { Injectable } from "@angular/core";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

export interface PaginationParams {
  page?: string;
  limit?: string;
  sortField?: string;
  sortOrder?: string;
  search?: string;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class BaseService {
  constructor(protected http: HttpClient) {}

  /**
   * Realiza una petición GET
   */
  protected get<T>(
    url: string,
    params?: HttpParams | { [param: string]: string | string[] }
  ): Observable<T> {
    return this.http.get<T>(url, { params });
  }

  /**
   * Realiza una petición POST
   */
  protected post<T>(
    url: string,
    body: any,
    options?: { headers?: HttpHeaders }
  ): Observable<T> {
    return this.http.post<T>(url, body, options);
  }

  /**
   * Realiza una petición PUT
   */
  protected put<T>(
    url: string,
    body: any,
    options?: { headers?: HttpHeaders }
  ): Observable<T> {
    return this.http.put<T>(url, body, options);
  }

  /**
   * Realiza una petición PATCH
   */
  protected patch<T>(
    url: string,
    body: any,
    options?: { headers?: HttpHeaders }
  ): Observable<T> {
    return this.http.patch<T>(url, body, options);
  }

  /**
   * Realiza una petición DELETE
   */
  protected delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(url);
  }

  /**
   * Descarga un archivo (blob)
   */
  protected downloadFile(
    url: string,
    params?: HttpParams | { [param: string]: string | string[] }
  ): Observable<Blob> {
    return this.http.get(url, {
      params,
      responseType: "blob",
    });
  }

  /**
   * Construye parámetros de paginación
   */
  protected buildPaginationParams(params: PaginationParams): HttpParams {
    let httpParams = new HttpParams();

    if (params.page) httpParams = httpParams.set("page", params.page);
    if (params.limit) httpParams = httpParams.set("limit", params.limit);
    if (params.sortField)
      httpParams = httpParams.set("sortField", params.sortField);
    if (params.sortOrder)
      httpParams = httpParams.set("sortOrder", params.sortOrder);
    if (params.search) httpParams = httpParams.set("search", params.search);

    // Agregar otros parámetros personalizados
    Object.keys(params).forEach((key) => {
      if (
        !["page", "limit", "sortField", "sortOrder", "search"].includes(key) &&
        params[key] !== undefined
      ) {
        httpParams = httpParams.set(key, params[key]);
      }
    });

    return httpParams;
  }
}
